module.exports = __webpack_public_path__ + "img/4.0f0dba65.png";